<template>
  <div
    class="floating xy-b-15 xy-r-20 card has-shadow is-radius-large has-border-light p-3"
    :class="{ 'is-expanded': isModalExpanded }"
  >
    <div class="is-flex is-flex-direction-column is-full-height">
      <div class="is-flex-centered is-justify-content-space-between">
        <slot name="title" />
        <i
          @click="toggleSize"
          :class="`is-size-3 is-clickable cls ${isModalExpanded ? 'cls-shrink' : 'cls-expand-2'}`"
          :data-e2e="FloatingViewCypressAttribute.buttons.TOGGLE_SIZE"
        />
      </div>
      <div class="m-t-10 m-b-10 is-flex-grow-1 is-overflow-auto">
        <slot name="content" :is-expanded="isModalExpanded" />
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { FloatingViewCypressAttribute } from '@/modules/core/app/constants/FloatingViewCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FloatingView',
  slotsDefinition: {
    title: {},
    content: { isExpanded: Boolean },
    footer: {}
  },
  props: {
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  static: {
    FloatingViewCypressAttribute
  },
  data() {
    return {
      isModalExpanded: this.isExpanded
    };
  },
  methods: {
    toggleSize() {
      this.isModalExpanded = !this.isModalExpanded;
    }
  }
};
</script>

<style scoped>
.floating {
  position: fixed;
  z-index: var(--ce-z-index-notification);
  height: var(--ce-380px);
  width: var(--ce-342px);
  transition: all 0.3s ease;
}

.floating.is-expanded {
  height: 85vh;
  width: 50vw;
}
</style>
